export function confirmedDelayMinutes(train) {
  if (!train) return 0;

  if (train.delay) {
    if (train.delay.state !== "confirmed") return 0;
    const confirmedMinutes = Number(train.delay.minutes ?? train.minutesLate);
    return Number.isFinite(confirmedMinutes) ? Math.max(0, confirmedMinutes) : 0;
  }

  const status = String(train.status || "").trim().toLowerCase();
  if (status === "on time") return 0;

  const legacyMinutes = Number(train.minutesLate);
  return Number.isFinite(legacyMinutes) ? Math.max(0, legacyMinutes) : 0;
}

export function displayStatus(train) {
  if (
    train?.delay &&
    train.delay.state !== "confirmed" &&
    train.holding !== true &&
    train.canceled !== true &&
    train.ghost !== true &&
    Number(train.minutesLate) > 0
  ) {
    return "On time";
  }

  return train?.status || "";
}
